import { COLORS } from 'constants/index';

export default {
    root: {},
    containedPrimary: {
        color: '#fff'
    },
    outlined: {
        fontSize: '16px !important',
        fontWeight: 600,
        borderWidth: '2px !important'
    },
    contained: {
        minHeight: 40,
        height: 'fit-content',
        fontSize: '16px !important',
        borderRadius: 2,
        '&:disabled': {
            color: '#fff',
            background: COLORS.apariBlack20
        }
    },
    outlinedPrimary: {
        minHeight: 40,
        height: 'fit-content',
        fontSize: '16px !important',
        borderRadius: 2,
        border: '1px solid ' + COLORS.apariLightBlue,
        '&:disabled': {
            color: COLORS.apariBlack20,
            background: 'transparent',
            border: '1px solid ' + COLORS.apariBlack20
        }
    },
    outlinedSecondary: {
        minHeight: 40,
        height: 'fit-content',
        borderRadius: 12,
        border: '1px solid ' + COLORS.paperLight,
        '&:disabled': {
            color: COLORS.paperLight,
            border: '1px solid ' + COLORS.paperLight,
            opacity: 0.5
        }
    },
    outlinedSizeSmall: {
        minHeight: 30,
        height: 'fit-content',
        paddingTop: 2,
        paddingBottom: 2
    },
    containedSizeSmall: {
        minHeight: 30,
        height: 'fit-content'
    },
    outlinedSizeLarge: {
        minHeight: 50,
        height: 'fit-content'
    },
    containedSizeLarge: {
        minHeight: 50,
        height: 'fit-content'
    },
    text: {
        fontSize: 12,
        fontWeight: 500,
        color: COLORS.apariBlack80,
        '&:hover': {
            background: 'transparent'
        }
    }
};
